import {useApp} from "../../app.context";
import {useDrag} from "react-dnd";
import AssetImage from "../../elements/assetImage.element";
import {useIntegrator} from "../../integrator.context";
import Checkmark from "../../elements/checkmark";

function TechUnlock(props: { nodeId: string, id: string, cancelDrag(): void }) {
    const {state} = useIntegrator();
    const {setNotification, setUnit} = useApp();

    // Resolve through ImagePacks for buildings (their image lives at
    // pack[startLevel][0], not under the bare uid). Units and tech-attribute
    // unlocks key images by their own id, so they fall through unchanged.
    const buildingData = state.buildings.find(b => b.id === props.id);
    const imageKey = (() => {
        if (!buildingData) return props.id;
        const pack = state.imagePacks?.[props.id];
        if (!pack || pack.length === 0) return props.id;
        const level = Math.max(0, Math.min(pack.length - 1, buildingData.startLevel));
        return pack[level]?.[0] ?? props.id;
    })();

    const [{isDragging}, drag] = useDrag({
        type: 'entity',
        item: {
            nodeId: props.nodeId,
            id: props.id
        },
        end: () => {
            props.cancelDrag();
        },
        collect: (monitor) => {
            return {
                isDragging: monitor.isDragging(),
            };
        }
    });

    function onClick() {
        const unit = state.units.find(u => u.id === props.id);
        if (unit !== undefined) {
            setUnit(unit.id);
        } else {
            const price = getPrice();
            setNotification({
                title: props.id,
                message: `${props.id}.description`,
                edit: true,
                headerRight: price !== undefined && <div className={'layout horizontal center gap'}>
                    <p>{price}</p>
                    <AssetImage id={'gold'} size={30} background={'transparent'} upload={false}/>
                </div>
            });
        }
    }

    function getPrice(): number | undefined {
        return state.buildings.find(b => b.id === props.id)?.price;
    }

    return (
        <div ref={drag}
             style={{opacity: isDragging ? 0.5 : 1}}
             onClick={onClick}>
            <div style={{position: 'relative'}}>
                <AssetImage id={imageKey} size={30} upload={false}/>
                <Checkmark id={props.id} style={{position: 'absolute', top: 0, right: 0}}/>
            </div>
        </div>
    )
}

export default TechUnlock;